export class ConcurrencyError extends Error {
  constructor(message?: string | undefined, public traceId?: string) {
    super(message);
  }
}
